var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartcontainer w-100 elevation-4"},[_c('LineChartGenerator',{ref:"line",attrs:{"dir":"rtl","chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"width":_vm.chartWidth,"height":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }